import { AxiosInstance } from "axios";
import {
  IFilterSchema,
  IListQueryStringSchema,
  ISortSchema,
} from "../../Schemas/ListQueryString";
import { IResponseBody } from "../../Schemas/EndPoint";
import { TicketListItemSchema } from "../../Schemas/Ticket";

interface Filter extends IFilterSchema {
  column: TicketListColumnFilterable;
}

interface Sort extends ISortSchema {
  column: TicketListColumnSortable;
}

export enum TicketListColumnFilterable {
  CAPTION = "caption",
  DEPARTMENT = "department",
  TICKET_NUMBER = "ticket_number",
  STATUS = "status",
  UPDATED_AT = "updated_at",
  CREATOR_USER_ID = "creator_user_id",
}
export enum TicketListColumnSortable {
  CAPTION = "caption",
  DEPARTMENT = "department",
  TICKET_NUMBER = "ticket_number",
  STATUS = "status",
  UPDATED_AT = "updated_at",
  CREATED_AT = "created_at",
  CREATOR_USER_ID = "creator_user_id",
  ID="id"
}
export interface TicketListQueryString extends IListQueryStringSchema {
  filters?: Filter[];
  sorts?: Sort[];
}

export interface TicketListUrlParams {
  workspaceId: number;
}

export interface TicketListResponseBody extends IResponseBody {
  data: {
    tickets: TicketListItemSchema[];
    total: number;
  };
}

export class TicketListRequest {
  private protectedAxiosInstance: AxiosInstance;

  constructor(protectedAxiosInstance: AxiosInstance) {
    this.protectedAxiosInstance = protectedAxiosInstance;
  }

  private getPath() {
    return `/admin/tickets`;
  }

  async send(
    queryStrings?: TicketListQueryString
  ): Promise<TicketListResponseBody> {
    try {
      const { data } = await this.protectedAxiosInstance.get(this.getPath(), {
        params: queryStrings,
      });
      return data;
    } catch (err) {
      // TODO : handle error
      throw err;
    }
  }
}
